import React from "react";
import { Link } from "react-router-dom";
import Banner from "../Images/hero.jpg";

const Hero = () => {
     const image = Banner;
  return (
    <div className="mt-0 relative w-full h-[100vh] overflow-hidden font-lato">
      {/* Static Background Image */}
      <div
        className="absolute inset-0 w-full h-full bg-center "
        style={{
          backgroundImage: `url(${image})`,
        }}
      ></div>

      {/* Overlay Content */}
      <div className="absolute inset-0 flex flex-col items-center justify-center bg-black bg-opacity-5 text-white text-center px-4">
        <h1 className="text-xl md:text-3xl lg:text-4xl font-bold mb-4">
          Welcome to The Great Himalayas Cab Services !
        </h1>
        <p className="text-sm md:text-lg lg:text-xl">Enjoy the Trip!</p>

        {/* Book Now Button */}
        <Link to="/bookCabs">
  <button className="mt-10 px-10 py-3 bg-gray-100 text-blue-500 font-semibold rounded hover:bg-gray-200 transition">
    Book Your Cab
  </button>
</Link>
      </div>
    </div>
  );
};

export default Hero;
